import React, { useState } from "react";
import type { IAdvancedSearchProps } from "./dto";
import "./index.less";

import IconFunnel from "../../assets/funnel.svg";
import IconFunnelBlue from "../../assets/funnel-blue.svg";

const AdvancedSearch = (props: IAdvancedSearchProps) => {
  const {
    resetText,
    searchText,
    expanded: expandedFlag,
    onExpand,
    onReset,
    onSearch,
  } = props;
  const [expanded, setExpanded] = useState<boolean>(expandedFlag);

  const handleClickFunnel = () => {
    setExpanded((oldV) => {
      onExpand?.(!oldV);
      return !oldV;
    });
  };

  const handleClickReset = () => {
    onReset?.();
  };

  const handleClickSearch = () => {
    onSearch?.();
  };

  return (
    <div className="advanced-search-container">
      <div className="funnel-container" onClick={handleClickFunnel}>
        <img
          className="icon-funnel"
          src={expanded ? IconFunnelBlue : IconFunnel}
          alt="advanced-search"
        />
      </div>
      <div className="text-container">
        <div className="text-btn text-reset" onClick={handleClickReset}>
          {resetText || "重置"}
        </div>
        <div className="text-btn text-search" onClick={handleClickSearch}>
          {searchText || "搜索"}
        </div>
      </div>
    </div>
  );
};

export default AdvancedSearch;
